(function () {
  const STORAGE_KEY = 'pilgrim_breadcrumb_collection';
  const MAX_AGE_MS = 30 * 60 * 1000;

  function readStoredCollection() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;

      const data = JSON.parse(raw);
      if (!data?.url || !data?.title) return null;
      if (data.ts && Date.now() - data.ts > MAX_AGE_MS) {
        sessionStorage.removeItem(STORAGE_KEY);
        return null;
      }

      return data;
    } catch (error) {
      return null;
    }
  }

  function saveCollectionContext() {
    const el = document.getElementById('pilgrim-collection-context');
    if (!el) return;

    try {
      const data = JSON.parse(el.textContent);
      if (!data?.url || !data?.title) return;

      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          handle: data.handle,
          title: data.title,
          url: data.url,
          ts: Date.now(),
        })
      );
    } catch (error) {}
  }

  function enhanceBreadcrumb() {
    const data = readStoredCollection();
    if (!data) return;

    const root = document.querySelector('[data-pilgrim-breadcrumb]');
    if (!root) return;

    const wrap = root.querySelector('[data-pilgrim-breadcrumb-collection-wrap]');
    const link = root.querySelector('[data-pilgrim-breadcrumb-collection]');
    const back = root.querySelector('[data-pilgrim-breadcrumb-back]');

    if (wrap) wrap.classList.remove('hidden');
    if (link) {
      link.href = data.url;
      link.textContent = data.title;
    }
    if (back) {
      back.href = data.url;
      back.setAttribute('aria-label', data.title);
    }
  }

  function init() {
    saveCollectionContext();
    enhanceBreadcrumb();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
